export const UPDATE_PAGE = 'speakeasy/Layout/UPDATE_PAGE';

export const LOG_IN_SUCCESS = 'speakeasy/login/LOG_IN_SUCCESS';
